define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/getProto.js
// module id = 108
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24